import React from 'react';
import { Dropdown, Menu, Space } from '@arco-design/web-react';
import { IconCaretDown, IconPoweroff } from '@arco-design/web-react/icon';
import { useStore } from '@/store';
import styles from './style/index.module.less';
import { logout } from '@/utils/auth';
import { observer } from 'mobx-react-lite';
import Todo from '@/components/NavBar/components/Todo';
import TodoCount from '@/components/TodoCount';
import { useTodoNotification } from '@/utils/hooks/useTodoNotification';
import TabFeatureSwitch from '@/components/NavBar/components/TabFeatureSwitch';
import TrackingEntry from '@/components/NavBar/components/TrackingEntry';

import UserAvatar from '@/components/UserAvatar';
import { apiLogout } from '@/api/system';
import { getOrg } from '@/utils/hooks/useOrg';

type Props = {
  tabFeatureEnabled?: boolean;
  onTabFeatureChange?: (enabled: boolean) => void;
  todoPanelVisible?: boolean;
  onTodoPanelOpen?: () => void;
  tabBar?: React.ReactNode;
};

function Navbar({
  tabFeatureEnabled = true,
  onTabFeatureChange,
  todoPanelVisible = false,
  onTodoPanelOpen,
  tabBar,
}: Props) {
  const { member, userInfo, userLoading } = useStore('user');
  const { orgId = '' } = getOrg();
  useTodoNotification(orgId);

  const onLogout = () => {
    logout(false);
  };
  const onMenuItemClick = async (key: string) => {
    if (key === 'logout') {
      await apiLogout();
      onLogout();
    }
  };
  const dropList = (
    <Menu onClickMenuItem={onMenuItemClick}>
      <Menu.Item key="logout" className={styles['dropdown-item-logout']}>
        <IconPoweroff className={styles['dropdown-icon']} />
        退出登录
      </Menu.Item>
    </Menu>
  );
  // const orgDropList = (
  //   <Menu onClickMenuItem={onOrgMenuClick}>
  //     {organizationList.map((item) => (
  //       <Menu.Item key={item.id || ''}>
  //         &nbsp;&nbsp;{item.name}&nbsp;&nbsp;
  //       </Menu.Item>
  //     ))}
  //   </Menu>
  // );
  return (
    <div className={styles.navbar}>
      <TodoCount orgId={orgId} />
      <div className={styles.left}>{tabBar}</div>
      <Space className={styles.right} size={18}>
        <TrackingEntry />
        <TabFeatureSwitch
          enabled={tabFeatureEnabled}
          onChange={(enabled) => onTabFeatureChange?.(enabled)}
        />
        <Todo active={todoPanelVisible} onOpen={onTodoPanelOpen} />
        {/* {curOrganization && (
          <Dropdown droplist={orgDropList} position="br" trigger={'click'}>
            <Space size={4} style={{ cursor: 'pointer' }}>
              {curOrganization?.name}
              <IconCaretDown
                style={{ display: 'flex', alignItems: 'center' }}
              />
            </Space>
          </Dropdown>
        )} */}
        {(!userLoading || userInfo || member) && (
          <Dropdown droplist={dropList} position="br" trigger={'click'}>
            <Space size={4} style={{ cursor: 'pointer' }}>
              <UserAvatar name={member?.name || userInfo?.name || ''} />
              {member?.name || userInfo?.name}
              <IconCaretDown
                style={{ display: 'flex', alignItems: 'center' }}
              />
            </Space>
          </Dropdown>
        )}
      </Space>
    </div>
  );
}

export default observer(Navbar);
